// App-side delegate for `@heidi/session/data` (D5, ARCFE-990). The hook
// moved; this file composes the CAPTURE gate per the ratified cohort-C rule —
// the offline predicate over the session cache is read here, at render time,
// exactly as the legacy hook read it, and crosses as a boolean input.

// LOAD-BEARING side-effect import — the legacy module's first value import,
// kept as part of this delegate's graph. `@/pages/api/scribeAPI` reaches
// `@/utils/scribeHTTP`, which value-imports `@/store`, so evaluating this
// module initializes the store↔scribeRecordModel cycle from the safe
// direction; suites import this delegate (unmocked) BEFORE a real
// `@/models/scribeRecordModel` import, and dropping the graph surfaces the
// "Cannot access 'scribeRecordModel' before initialization" TDZ there.
// Deleted with this delegate at Z2.
import '@/pages/api/scribeAPI';

import { isOfflineLocalSession } from '@/utils/offline-recording/localSessionSettings';
import { reactQueryClient } from '@/utils/reactQueryClient';
import {
  GET_DEMO_DOCUMENTS_BY_ID,
  GET_DOCUMENTS_BY_ID,
  GET_SESSION_BY_ID,
  type QuerySessionResponse,
} from '@heidi/session/contracts';
import { useQueryDocumentsBySessionId as useQueryDocumentsBySessionIdCore } from '@heidi/session/data';

export { GET_DEMO_DOCUMENTS_BY_ID, GET_DOCUMENTS_BY_ID };

export function useQueryDocumentsBySessionId(sessionId: string) {
  const sessionData = reactQueryClient.getQueryData<QuerySessionResponse>([
    GET_SESSION_BY_ID,
    { sessionId },
  ]);

  return useQueryDocumentsBySessionIdCore(sessionId, {
    isOfflineLocalSession: isOfflineLocalSession(sessionData),
  });
}

/** Legacy alias — the "authenticated" variant was the implementation. */
export const useQueryDocumentsBySessionIdAuthenticated = useQueryDocumentsBySessionId;
